module.exports = __webpack_public_path__ + "media/images/wfc/city-5-874db954e8ab28058631775cda0ac3a0.jpg";